const PictViewClass = require('pict-view');

class LIMSLocationRecordCreate extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.AppData.LocationDetails = {};
		this.ActiveLocationLogs = [];
		this.LIMSLocationRecordBackTo = null;
		this.manifest = require('./defaultLocationCreateManifest.json');
	}

	async onBeforeRenderAsync(pCallback, pRenderable)
	{
		this.AppData.LocationDetails = {};
		const session = await this.pict.providers.SessionProvider.getSession();
		this.pict.PictApplication.changeTheme('Create');
		if (!this.initialized || (session.CustomerID !== this.customer))
		{
			this.customer = session.CustomerID;
			// Check for a manifest from the DB before loading the default.
			const remoteManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Location', 'Create', this.pict.PictApplication.options.pict_configuration.Product);
			this.manifest = remoteManifest || this.manifest;
			this.pict.views.PictFormMetacontroller.clearManifestDescription();
			this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.manifest);
			this.pict.views['PictSectionForm-LocationCreate'].viewMarshalDestination = 'AppData';
			this.pict.views['PictSectionForm-LocationCreate'].options.DefaultDestinationAddress = '#LIMSLocationRecordCreate-View-Container';
			// @ts-ignore
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
			this.pict.views['PictSectionForm-LocationCreate'].rebuildCustomTemplate();
			this.initialized = true;
		}
		super.onBeforeRenderAsync(async () =>
		{
			try
			{
				this.pict.views['PictSectionForm-LocationCreate'].rebuildCustomTemplate();
				this.log.info('Location Details view rendered with Active Record', this.AppData.LocationDetails);
			}
			catch (error)
			{
				this.log.error('Error in Location Details onBeforeRenderAsync:', error);
			}
			return pCallback();
		}, pRenderable);
	}

	async clearLocation(pRender = true)
	{
		this.AppData.LocationDetails = {};
		if (pRender)
		{
			await new Promise((resolve) => this.renderAsync(() =>
			{
				this.log.info('Location Create view cleared');
				resolve();
			}));
		}
	}

	/**
	 * Open the Location detail view for the selected Location to view the full details
	 * @param {number|string} pIDLocation - The ID of the Location to view
	 * @param {object} pLocationRecord - The Location record to view
	 * @param {string} pOpenTab - The tab to open when the Location detail view is shown
	 * @return {Promise<void>}
	 * @async
	 */
	async showLocationDetailView(pIDLocation, pLocationRecord, pOpenTab = 'Details')
	{
		// if a Location record is passed in, use it, otherwise get the Location record by ID
		if (pLocationRecord)
		{
			this.AppData.LocationDetails = Array.isArray(pLocationRecord) ? pLocationRecord[0] : pLocationRecord;
		}
		else
		{
			const tmpRecord = await this.pict.providers.LocationProvider.getLocationByID(pIDLocation);
			this.AppData.LocationDetails = tmpRecord;
		}
		// render the Location detail view
		await new Promise((resolve, reject)=>
		{
			this.renderAsync(() =>
			{
				this.log.info('Location Details View Rendered with Active Record', this.AppData.LocationDetails);
				resolve();
			});
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.views['PictSectionForm-LocationCreate'].render();
		this.pict.views['PictSectionForm-LocationCreate'].marshalToView();

		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	/**
	 * This method is used to handle the Print button click for building the print view.
	 * @return {void}
	 */
	printQRCodeLabel()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('No active Location to print QR Code for');
			return;
		}
		this.log.info('Printing Location Details');
		this.pict.providers.QRCodeProvider.printDecoratedEntity('Location', this.AppData.LocationDetails.QRCode);
	}

	goToCreateView()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('[Location-Record-Create] No active Location to Create');
			return;
		}
		this.log.info('[Location-Record-Create] Going to Create Location view for Location GUID:', this.AppData.LocationDetails.GUIDLocation);
		this.pict.providers.LIMSRouter.router.navigate(`/Location/${this.AppData.LocationDetails.GUIDLocation}/Create`);
	}

	confirmDeleteLocation()
	{
		// prompt a confirmation modal to do the deletion
		this.fable.HeadlightModal.spawnModal({
			title: 'Delete Location',
			modalBodyTemplate: /*html*/`
			<div class="container column is-12">
				<p class="title is-5
				has-text-centered p-2 mb-5">
					<span class="icon">
						<i class="fa fa-fw fa-exclamation-triangle has-text-danger"></i>
					</span>
					<span> Are you sure you want to delete this Location?</span>
				</p>
				<p class="is-6 has-text-centered">This action is irreversible and will permanently delete</p>
				<p class="has-text-centered m-3"><strong>${ this.AppData.LocationDetails.Name }</strong></p>
				<p class="is-6 has-text-centered">Please click button below to confirm deletion or close this modal.</p>
			</div>`,
			modalFooterTemplate: /*html*/`
			<div class="buttons is-right">
				<button class="button is-danger is-soft" type="button" title="Cancel Deletion" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
					<span class="icon">
						<i class="fas fa-fw fa-times" aria-hidden="true"></i>
					</span>
					<span>Cancel</span>
				</button>
				<button class="button is-danger" type="button" title="Delete Location" onclick="_Pict.views.LIMSLocationRecordCreate.deleteLocation()">
					<span class="icon">
						<i class="fas fa-fw fa-trash" aria-hidden="true"></i>
					</span>
					<span>Delete Location</span>
				</button>
			</div>`,
			confirmText: 'Delete Location',
			cancelText: 'Cancel',
		});
	}

	deleteLocation()
	{
		if (!this.AppData.LocationDetails)
		{
			this.log.error('[Location-Record-Create] No active Location to delete');
			return;
		}
		this.log.info('[Location-Record-Create] Deleting Location ID:', this.AppData.LocationDetails.IDLocation);
		this.pict.HeadlightRestClient.deleteEntity('Location', this.AppData.LocationDetails.IDLocation, () =>
		{});
		this.pict.providers.LIMSRouter.router.navigate('/PSRS/Location/List');
		this.pict.fable.services.HeadlightModal.dismissModals();
	}

	toggleTabContent(event, pTabID)
	{
		// clear the active class from all tabs
		const tmpTabs = document.querySelectorAll('.tabs ul li');
		tmpTabs.forEach((tab) =>
		{
			tab.classList.remove('is-active');
		});
		// set the active class on the selected tab
		const tmpActiveTab = event.currentTarget;
		if (tmpActiveTab)
		{
			tmpActiveTab?.parentElement.classList.add('is-active');
		}
		// hide all the tab content
		const tmpTabContent = document.querySelectorAll('.tab-content');
		tmpTabContent.forEach((content) =>
		{
			content.classList.remove('is-active');
		});
		// show the selected tab content
		const tmpActiveTabContent = document.getElementById(`${pTabID}-Content`);
		if (tmpActiveTabContent)
		{
			tmpActiveTabContent.classList.add('is-active');
		}
	}

	async createNewLocation(event)
	{
		// prevent the form refeshing the page
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		event.currentTarget.classList.add('is-loading');
		this.log.info('Creating new Location...');
		this.log.info(JSON.stringify(this.AppData.LocationDetails));

		const tmpLocation = this.AppData.LocationDetails;

		// save the Location
		try
		{
			delete tmpLocation.CreatingIDUser;
			const tmpResult = await new Promise((resolve, reject) =>
			{
				this.pict.HeadlightRestClient.upsertEntity('Location', tmpLocation, (pError, pResult) =>
				{
					if (pError)
					{
						reject(pError);
					}
					resolve(pResult);
				});
			});
			this.AppData.LocationDetails = tmpResult;
			this.log.info('Location created, going to the Details view...');
			this.goToReadView();
		}
		catch (error)
		{
			this.log.error('Error creating Location', error);
			this.pict.views.HeadlightPanels.toast({ message: `Error creating Location: ${error.message || error}`, type: 'is-danger' });
		}
	}

	goToReadView(pEvent)
	{
		if (pEvent)
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
		}
		if (!this.AppData.LocationDetails)
		{
			this.log.error('No active Location to view');
			return;
		}
		this.log.info('Going to Read Location view for Location GUID:', this.AppData.LocationDetails.GUIDLocation);
		this.pict.providers.LIMSRouter.router.navigate(`/Location/${ this.AppData.LocationDetails.GUIDLocation }`);
	}

	handleFormSubmitAction(event)
	{
		event.preventDefault();
		event.stopPropagation();
		this.log.info('Location form submitted');

		this.createNewLocation(event);
	}
}

module.exports = LIMSLocationRecordCreate;

module.exports.default_configuration =
{
	ViewIdentifier: 'LIMSLocationRecordCreate',
	DefaultRenderable: 'LIMSLocationRecordCreate',
	DefaultDestinationAddress: '#LIMS-Application-Container',
	CSS: /*css*/`
		.tab-content {
			display: none;
		}
		.tab-content.is-active {
			display: block;
		}`,
	Templates:
	[
		{
			Hash: 'LIMSLocationRecordCreate-Wrapper',
			Template: /*html*/`
			<form class="container form" data-location-id="{~D:Record.IDLocation~}" onsubmit="_Pict.views.LIMSLocationRecordCreate.handleFormSubmitAction(event);">
				{~T:LIMSLocationRecordCreate-LocationHeader:AppData.LocationDetails~}
				<!-- LIMSLocationRecord Content > Tab Details View -->
				<div id="LIMSLocationRecordCreatePanel-Details-Content" class="tab-content is-active">
					<div id="LIMSLocationRecordCreate-Details-Container">{~T:LIMSLocationRecordCreate-Tab-Details:AppData.LocationDetails~}</div>
				</div>
			</form>`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-LocationHeader',
			Template: /*html*/`
			<header id="PRSP_Title_Container" class="p-5 pb-0 has-background-text-soft is-vcentered">
				<h2 class="title is-size-4" id="PRSP_Title">Create New Location</h2>
			</header>`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-Tab-Details',
			Template: /*html*/`
			<!-- Placeholder for dynamic section -->
			<div id="LIMSLocationRecordCreate-View-Container" class="app-page-gutters-for-mobile px-5 mt-2"></div>
			{~T:LIMSLocationRecordCreate-Tab-Details-Buttons-Create:AppData.LocationDetails~}`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-Tab-Details-Buttons-Create',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column px-3 py-1 has-text-right">
					<button type="button" class="button is-link is-soft" title="Clear Location" onclick="_Pict.views.LIMSLocationRecordCreate.clearLocation(true)">
						<span class="icon">
							<i class="fa fa-fw fa-refresh"></i>
						</span>
						<span class="icon-text">Clear</span>
					</button>
					<button type="submit" class="button is-link" title="Create new location">
						<span class="icon">
							<i class="fa fa-fw fa-save"></i>
						</span>
						<span class="icon-text">Save New Location</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-EntityValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-DatumValue',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-DatumValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-DatumValue-Name',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-DatumValue-Name-Empty',
			Template: /*html*/`Unnamed Location #{~D:Record.IDLocation~}`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-DatumValue-Description',
			Template: /*html*/`{~D:Record.Description~}`,
		},
		{
			Hash: 'LIMSLocationRecordCreate-DatumValue-ParentLocation',
			Template: /*html*/`{~D:Record.ParentLocation.Name~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'LIMSLocationRecordCreate',
			TemplateHash: 'LIMSLocationRecordCreate-Wrapper',
			DestinationAddress: '#LIMS-Application-Container',
			RenderType: 'replace',
		},
	],
};
